import { label, labelSecondary, white } from 'styles'

import { makeStyles } from '@mui/styles'

export default makeStyles({
  details: {
    '& .MuiAccordionDetails-root': {
      background: white,
    },
  },
  root: {
    padding: '0',
    width: 'auto',

    // Each country
    '& > div:first-child': {
      background: labelSecondary,
      boxShadow: 'none',
      borderBottom: `1px solid ${label}`,
      borderRadius: '0',
    },

    // Last country
    '&:last-child > div:first-child': {
      borderBottom: 'none',
      borderBottomLeftRadius: '0.7rem',
      borderBottomRightRadius: '0.7rem',
    },
  },
})
